import { useEffect, useState } from 'react'
import { fetchQuietDaysCheckin, type QuietDaysCheckin } from '../services/withYouService'

/** The pending quiet-days check-in for the signed-in user, if any (2026-09-15). */
export function useQuietDaysCheckin() {
  const [data, setData] = useState<QuietDaysCheckin | null>(null)
  const [fetched, setFetched] = useState(false)
  const refresh = async () => {
    try { setData(await fetchQuietDaysCheckin()) } catch { setData(null) }
    setFetched(true)
  }
  useEffect(() => { void refresh() }, [])
  return { data, count: fetched ? (data ? 1 : 0) : null, refresh }
}
